import { backendURL } from "../utils/constants/constants";

export async function postFileBase64({ body, token }) {

    try {
        const response = await fetch(`${backendURL}/masters/cargarArchivoBase64`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(body)
        });

        const data = await response.text();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}


export async function postDeleteFileBase64({ body, token }) {

    try {
        const response = await fetch(`${backendURL}/masters/eliminarArchivoServidor`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(body)
        });
        return response;
    } catch (e) {
        throw (e);
    }
}